<template>
    <div class="wrapper">
        <div class="left" @click="collapseChage" :class="collapse ? 'left1' : ''">
            <img src="../../assets/img/left.png" alt="" :class="collapse ? 'left-collapse' : ''" />
        </div>
        <v-sidebar :collapse="collapse"></v-sidebar>
        <div class="content-box" :class="{ 'content-collapse': collapse }">
            <div class="content">
                <transition name="move" mode="out-in">
                    <!-- <keep-alive :include="tagsList"> -->
                    <router-view></router-view>
                    <!-- </keep-alive> -->
                </transition>
                <el-backtop target=".content"></el-backtop>
            </div>
        </div>
    </div>
</template>
<script>
import vSidebar from './Sidebar.vue';

export default {
    data() {
        return {
            tagsList: [],
            collapse: false
        };
    },
    components: {
  
        vSidebar,
      
    },

    created() {
        if (window.history && window.history.pushState) {
            history.pushState(null, null, document.URL);
            window.addEventListener('popstate', this.goBack, false);
        }
        // bus.$on('collapse-content', (msg) => {
        //     this.collapse = msg;
        // });

        // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
        // bus.$on('tags', (msg) => {
        //     let arr = [];
        //     for (let i = 0, len = msg.length; i < len; i++) {
        //         msg[i].name && arr.push(msg[i].name);
        //     }
        //     this.tagsList = arr;
        // });
    },
    destroyed() {
        window.removeEventListener('popstate', this.goBack, false);
        if (localStorage.getItem('user_type') == 'user') {
            this.$router.replace({ path: '/detail' });
        } else {
            this.$router.replace({ path: '/dashboard' });
        }
    },
    methods: {
        collapseChage() {
            this.collapse = !this.collapse;
            // bus.$emit('collapse', this.collapse);
        },
        goBack() {}
    }
};
</script>
<style lang="scss" scoped>
.left {
    position: absolute;
    width: 26px;
    height: 26px;
    left: 187px;

    top: 76px;
    background: #effafe;
    border-radius: 50%;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-transition: left 0.3s ease-in-out;
    transition: left 0.3s ease-in-out;
    img {
        width: 24px;
        height: 24px; 
    }
}
.left1 {
    left: 65px !important;
    -webkit-transition: right 0.3s ease-in-out;
    transition: right 0.3s ease-in-out;
}
.left-collapse {
    transform: rotateY(180deg);
}
</style>
